import FontAwesome from 'components/util/FontAwesome';
import React from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import Moment from 'react-moment';
import { Link } from 'react-router-dom';
import ChatlogContext from './ChatlogContext';

type Props = {
  msg: string;
  msg_type: string;
  msg_time: number;
  client_name: string;
  client_id: number;
  onClick: Function;
  highlighted: boolean;
  id: number;
  server_id: string;
  key: string;
  contextLink?: boolean;
}

const ChatlogMessage = ({
  msg,
  msg_type,
  client_name,
  client_id,
  onClick,
  msg_time,
  highlighted,
  id,
  server_id,
  key,
  contextLink = false,
} : Props) => {
  return (
    <tr
      className={"ChatMessage" + (highlighted ? " highlighted" : "")}
      onClick={() => onClick(id)}
      key={key}
    >
      <td className="col-2">
        <Moment unix format="MM/DD/YYYY hh:mm:ssa">
          {msg_time}
        </Moment>
      </td>
      <td className="col-2">
        <Link
          to={`/echelon/clientDetails/${client_id}`}
          onClick={(e) => e.stopPropagation()}
        >
            <i className="fa fa-user" />
          &nbsp;
        </Link>
        <OverlayTrigger
          // @ts-ignore
          placement="below"
          overlay={
            <Tooltip id={"tooltip-chatmessage-" + client_id}>
              {client_id}
            </Tooltip>
          }
        >
          <a
            href={`#${client_name}`}
            onClick={(e) => {
              e.stopPropagation();
              onClick(client_name);
            }}
          >
            {client_name}
          </a>
        </OverlayTrigger>
        {contextLink && <span className="right">
            <ChatlogContext serverid={server_id} chatid={id} />
          </span>}
      </td>
      <td className={"col message" + (msg_type === "MUTED" ? " muted" : "")}>
        {msg_type === "MUTED" && (
          <>
            <FontAwesome icon="microphone" />
            &nbsp;
          </>
        )}
        {msg_type === "TEAM" && <span className="teammsg">(team) </span>}
        {msg}
      </td>
    </tr>
  );
}

export const ChatlogMessageWithContext = (props : Props) => {
  return ChatlogMessage({...props, contextLink: true});
}

export default ChatlogMessage